import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import withOrganization from 'App/Decorators/withOrganization'
import {withRouter} from 'react-router'

@withOrganization
@withRouter
export default class Layout extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    children: PropTypes.node,
    organization: PropTypes.object
  }

  render() {
    if (!this.props.organization || this.props.organization.slug !== 'securitysat') {
      console.log('Route /Preparation/Layout  !org');
      return this.props.router.push('/')
    }
    return <div className={styles.container}>{this.props.children}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/Layout/index.js